// ISO 3166-1 alpha-3
// https://en.wikipedia.org/wiki/ISO_3166-1_alpha-3
export enum CountryCode {
  ABW = 'ABW',
  AFG = 'AFG',
  AGO = 'AGO',
  AIA = 'AIA',
  ALA = 'ALA',
  ALB = 'ALB',
  AND = 'AND',
  ARE = 'ARE',
  ARG = 'ARG',
  ARM = 'ARM',
  ASM = 'ASM',
  ATA = 'ATA',
  ATF = 'ATF',
  ATG = 'ATG',
  AUS = 'AUS',
  AUT = 'AUT',
  AZE = 'AZE',
  BDI = 'BDI',
  BEL = 'BEL',
  BEN = 'BEN',
  BES = 'BES',
  BFA = 'BFA',
  BGD = 'BGD',
  BGR = 'BGR',
  BHR = 'BHR',
  BHS = 'BHS',
  BIH = 'BIH',
  BLM = 'BLM',
  BLR = 'BLR',
  BLZ = 'BLZ',
  BMU = 'BMU',
  BOL = 'BOL',
  BRA = 'BRA',
  BRB = 'BRB',
  BRN = 'BRN',
  BTN = 'BTN',
  BVT = 'BVT',
  BWA = 'BWA',
  CAF = 'CAF',
  CAN = 'CAN',
  CCK = 'CCK',
  CHE = 'CHE',
  CHL = 'CHL',
  CHN = 'CHN',
  CIV = 'CIV',
  CMR = 'CMR',
  COD = 'COD',
  COG = 'COG',
  COK = 'COK',
  COL = 'COL',
  COM = 'COM',
  CPV = 'CPV',
  CRI = 'CRI',
  CUB = 'CUB',
  CUW = 'CUW',
  CXR = 'CXR',
  CYM = 'CYM',
  CYP = 'CYP',
  CZE = 'CZE',
  DEU = 'DEU',
  DJI = 'DJI',
  DMA = 'DMA',
  DNK = 'DNK',
  DOM = 'DOM',
  DZA = 'DZA',
  ECU = 'ECU',
  EGY = 'EGY',
  ERI = 'ERI',
  ESH = 'ESH',
  ESP = 'ESP',
  EST = 'EST',
  ETH = 'ETH',
  FIN = 'FIN',
  FJI = 'FJI',
  FLK = 'FLK',
  FRA = 'FRA',
  FRO = 'FRO',
  FSM = 'FSM',
  GAB = 'GAB',
  GBR = 'GBR',
  GEO = 'GEO',
  GGY = 'GGY',
  GHA = 'GHA',
  GIB = 'GIB',
  GIN = 'GIN',
  GLP = 'GLP',
  GMB = 'GMB',
  GNB = 'GNB',
  GNQ = 'GNQ',
  GRC = 'GRC',
  GRD = 'GRD',
  GRL = 'GRL',
  GTM = 'GTM',
  GUF = 'GUF',
  GUM = 'GUM',
  GUY = 'GUY',
  HKG = 'HKG',
  HMD = 'HMD',
  HND = 'HND',
  HRV = 'HRV',
  HTI = 'HTI',
  HUN = 'HUN',
  IDN = 'IDN',
  IMN = 'IMN',
  IND = 'IND',
  IOT = 'IOT',
  IRL = 'IRL',
  IRN = 'IRN',
  IRQ = 'IRQ',
  ISL = 'ISL',
  ISR = 'ISR',
  ITA = 'ITA',
  JAM = 'JAM',
  JEY = 'JEY',
  JOR = 'JOR',
  JPN = 'JPN',
  KAZ = 'KAZ',
  KEN = 'KEN',
  KGZ = 'KGZ',
  KHM = 'KHM',
  KIR = 'KIR',
  KNA = 'KNA',
  KOR = 'KOR',
  KWT = 'KWT',
  LAO = 'LAO',
  LBN = 'LBN',
  LBR = 'LBR',
  LBY = 'LBY',
  LCA = 'LCA',
  LIE = 'LIE',
  LKA = 'LKA',
  LSO = 'LSO',
  LTU = 'LTU',
  LUX = 'LUX',
  LVA = 'LVA',
  MAC = 'MAC',
  MAF = 'MAF',
  MAR = 'MAR',
  MCO = 'MCO',
  MDA = 'MDA',
  MDG = 'MDG',
  MDV = 'MDV',
  MEX = 'MEX',
  MHL = 'MHL',
  MKD = 'MKD',
  MLI = 'MLI',
  MLT = 'MLT',
  MMR = 'MMR',
  MNE = 'MNE',
  MNG = 'MNG',
  MNP = 'MNP',
  MOZ = 'MOZ',
  MRT = 'MRT',
  MSR = 'MSR',
  MTQ = 'MTQ',
  MUS = 'MUS',
  MWI = 'MWI',
  MYS = 'MYS',
  MYT = 'MYT',
  NAM = 'NAM',
  NCL = 'NCL',
  NER = 'NER',
  NFK = 'NFK',
  NGA = 'NGA',
  NIC = 'NIC',
  NIU = 'NIU',
  NLD = 'NLD',
  NOR = 'NOR',
  NPL = 'NPL',
  NRU = 'NRU',
  NZL = 'NZL',
  OMN = 'OMN',
  PAK = 'PAK',
  PAN = 'PAN',
  PCN = 'PCN',
  PER = 'PER',
  PHL = 'PHL',
  PLW = 'PLW',
  PNG = 'PNG',
  POL = 'POL',
  PRI = 'PRI',
  PRK = 'PRK',
  PRT = 'PRT',
  PRY = 'PRY',
  PSE = 'PSE',
  PYF = 'PYF',
  QAT = 'QAT',
  REU = 'REU',
  ROU = 'ROU',
  RUS = 'RUS',
  RWA = 'RWA',
  SAU = 'SAU',
  SDN = 'SDN',
  SEN = 'SEN',
  SGP = 'SGP',
  SGS = 'SGS',
  SHN = 'SHN',
  SJM = 'SJM',
  SLB = 'SLB',
  SLE = 'SLE',
  SLV = 'SLV',
  SMR = 'SMR',
  SOM = 'SOM',
  SPM = 'SPM',
  SRB = 'SRB',
  SSD = 'SSD',
  STP = 'STP',
  SUR = 'SUR',
  SVK = 'SVK',
  SVN = 'SVN',
  SWE = 'SWE',
  SWZ = 'SWZ',
  SXM = 'SXM',
  SYC = 'SYC',
  SYR = 'SYR',
  TCA = 'TCA',
  TCD = 'TCD',
  TGO = 'TGO',
  THA = 'THA',
  TJK = 'TJK',
  TKL = 'TKL',
  TKM = 'TKM',
  TLS = 'TLS',
  TON = 'TON',
  TTO = 'TTO',
  TUN = 'TUN',
  TUR = 'TUR',
  TUV = 'TUV',
  TWN = 'TWN',
  TZA = 'TZA',
  UGA = 'UGA',
  UKR = 'UKR',
  UMI = 'UMI',
  URY = 'URY',
  USA = 'USA',
  UZB = 'UZB',
  VAT = 'VAT',
  VCT = 'VCT',
  VEN = 'VEN',
  VGB = 'VGB',
  VIR = 'VIR',
  VNM = 'VNM',
  VUT = 'VUT',
  WLF = 'WLF',
  WSM = 'WSM',
  YEM = 'YEM',
  ZAF = 'ZAF',
  ZMB = 'ZMB',
  ZWE = 'ZWE',
}

const countryISOMapping: { [key: string]: CountryCode } = {
  AF: CountryCode.AFG,
  AX: CountryCode.ALA,
  AL: CountryCode.ALB,
  DZ: CountryCode.DZA,
  AS: CountryCode.ASM,
  AD: CountryCode.AND,
  AO: CountryCode.AGO,
  AI: CountryCode.AIA,
  AQ: CountryCode.ATA,
  AG: CountryCode.ATG,
  AR: CountryCode.ARG,
  AM: CountryCode.ARM,
  AW: CountryCode.ABW,
  AU: CountryCode.AUS,
  AT: CountryCode.AUT,
  AZ: CountryCode.AZE,
  BS: CountryCode.BHS,
  BH: CountryCode.BHR,
  BD: CountryCode.BGD,
  BB: CountryCode.BRB,
  BY: CountryCode.BLR,
  BE: CountryCode.BEL,
  BZ: CountryCode.BLZ,
  BJ: CountryCode.BEN,
  BM: CountryCode.BMU,
  BT: CountryCode.BTN,
  BO: CountryCode.BOL,
  BA: CountryCode.BIH,
  BW: CountryCode.BWA,
  BV: CountryCode.BVT,
  BR: CountryCode.BRA,
  VG: CountryCode.VGB,
  IO: CountryCode.IOT,
  BN: CountryCode.BRN,
  BG: CountryCode.BGR,
  BF: CountryCode.BFA,
  BI: CountryCode.BDI,
  KH: CountryCode.KHM,
  CM: CountryCode.CMR,
  CA: CountryCode.CAN,
  CV: CountryCode.CPV,
  KY: CountryCode.CYM,
  CF: CountryCode.CAF,
  TD: CountryCode.TCD,
  CL: CountryCode.CHL,
  CN: CountryCode.CHN,
  HK: CountryCode.HKG,
  MO: CountryCode.MAC,
  CX: CountryCode.CXR,
  CC: CountryCode.CCK,
  CO: CountryCode.COL,
  KM: CountryCode.COM,
  CG: CountryCode.COG,
  CD: CountryCode.COD,
  CK: CountryCode.COK,
  CR: CountryCode.CRI,
  CI: CountryCode.CIV,
  HR: CountryCode.HRV,
  CU: CountryCode.CUB,
  CY: CountryCode.CYP,
  CZ: CountryCode.CZE,
  DK: CountryCode.DNK,
  DJ: CountryCode.DJI,
  DM: CountryCode.DMA,
  DO: CountryCode.DOM,
  EC: CountryCode.ECU,
  EG: CountryCode.EGY,
  SV: CountryCode.SLV,
  GQ: CountryCode.GNQ,
  ER: CountryCode.ERI,
  EE: CountryCode.EST,
  ET: CountryCode.ETH,
  FK: CountryCode.FLK,
  FO: CountryCode.FRO,
  FJ: CountryCode.FJI,
  FI: CountryCode.FIN,
  FR: CountryCode.FRA,
  GF: CountryCode.GUF,
  PF: CountryCode.PYF,
  TF: CountryCode.ATF,
  GA: CountryCode.GAB,
  GM: CountryCode.GMB,
  GE: CountryCode.GEO,
  DE: CountryCode.DEU,
  GH: CountryCode.GHA,
  GI: CountryCode.GIB,
  GR: CountryCode.GRC,
  GL: CountryCode.GRL,
  GD: CountryCode.GRD,
  GP: CountryCode.GLP,
  GU: CountryCode.GUM,
  GT: CountryCode.GTM,
  GG: CountryCode.GGY,
  GN: CountryCode.GIN,
  GW: CountryCode.GNB,
  GY: CountryCode.GUY,
  HT: CountryCode.HTI,
  HM: CountryCode.HMD,
  VA: CountryCode.VAT,
  HN: CountryCode.HND,
  HU: CountryCode.HUN,
  IS: CountryCode.ISL,
  IN: CountryCode.IND,
  ID: CountryCode.IDN,
  IR: CountryCode.IRN,
  IQ: CountryCode.IRQ,
  IE: CountryCode.IRL,
  IM: CountryCode.IMN,
  IL: CountryCode.ISR,
  IT: CountryCode.ITA,
  JM: CountryCode.JAM,
  JP: CountryCode.JPN,
  JE: CountryCode.JEY,
  JO: CountryCode.JOR,
  KZ: CountryCode.KAZ,
  KE: CountryCode.KEN,
  KI: CountryCode.KIR,
  KP: CountryCode.PRK,
  KR: CountryCode.KOR,
  KW: CountryCode.KWT,
  KG: CountryCode.KGZ,
  LA: CountryCode.LAO,
  LV: CountryCode.LVA,
  LB: CountryCode.LBN,
  LS: CountryCode.LSO,
  LR: CountryCode.LBR,
  LY: CountryCode.LBY,
  LI: CountryCode.LIE,
  LT: CountryCode.LTU,
  LU: CountryCode.LUX,
  MK: CountryCode.MKD,
  MG: CountryCode.MDG,
  MW: CountryCode.MWI,
  MY: CountryCode.MYS,
  MV: CountryCode.MDV,
  ML: CountryCode.MLI,
  MT: CountryCode.MLT,
  MH: CountryCode.MHL,
  MQ: CountryCode.MTQ,
  MR: CountryCode.MRT,
  MU: CountryCode.MUS,
  YT: CountryCode.MYT,
  MX: CountryCode.MEX,
  FM: CountryCode.FSM,
  MD: CountryCode.MDA,
  MC: CountryCode.MCO,
  MN: CountryCode.MNG,
  ME: CountryCode.MNE,
  MS: CountryCode.MSR,
  MA: CountryCode.MAR,
  MZ: CountryCode.MOZ,
  MM: CountryCode.MMR,
  NA: CountryCode.NAM,
  NR: CountryCode.NRU,
  NP: CountryCode.NPL,
  NL: CountryCode.NLD,
  NC: CountryCode.NCL,
  NZ: CountryCode.NZL,
  NI: CountryCode.NIC,
  NE: CountryCode.NER,
  NG: CountryCode.NGA,
  NU: CountryCode.NIU,
  NF: CountryCode.NFK,
  MP: CountryCode.MNP,
  NO: CountryCode.NOR,
  OM: CountryCode.OMN,
  PK: CountryCode.PAK,
  PW: CountryCode.PLW,
  PS: CountryCode.PSE,
  PA: CountryCode.PAN,
  PG: CountryCode.PNG,
  PY: CountryCode.PRY,
  PE: CountryCode.PER,
  PH: CountryCode.PHL,
  PN: CountryCode.PCN,
  PL: CountryCode.POL,
  PT: CountryCode.PRT,
  PR: CountryCode.PRI,
  QA: CountryCode.QAT,
  RE: CountryCode.REU,
  RO: CountryCode.ROU,
  RU: CountryCode.RUS,
  RW: CountryCode.RWA,
  BL: CountryCode.BLM,
  SH: CountryCode.SHN,
  KN: CountryCode.KNA,
  LC: CountryCode.LCA,
  MF: CountryCode.MAF,
  PM: CountryCode.SPM,
  VC: CountryCode.VCT,
  WS: CountryCode.WSM,
  SM: CountryCode.SMR,
  ST: CountryCode.STP,
  SA: CountryCode.SAU,
  SN: CountryCode.SEN,
  RS: CountryCode.SRB,
  SC: CountryCode.SYC,
  SL: CountryCode.SLE,
  SG: CountryCode.SGP,
  SK: CountryCode.SVK,
  SI: CountryCode.SVN,
  SB: CountryCode.SLB,
  SO: CountryCode.SOM,
  ZA: CountryCode.ZAF,
  GS: CountryCode.SGS,
  SS: CountryCode.SSD,
  ES: CountryCode.ESP,
  LK: CountryCode.LKA,
  SD: CountryCode.SDN,
  SR: CountryCode.SUR,
  SJ: CountryCode.SJM,
  SZ: CountryCode.SWZ,
  SE: CountryCode.SWE,
  CH: CountryCode.CHE,
  SY: CountryCode.SYR,
  TW: CountryCode.TWN,
  TJ: CountryCode.TJK,
  TZ: CountryCode.TZA,
  TH: CountryCode.THA,
  TL: CountryCode.TLS,
  TG: CountryCode.TGO,
  TK: CountryCode.TKL,
  TO: CountryCode.TON,
  TT: CountryCode.TTO,
  TN: CountryCode.TUN,
  TR: CountryCode.TUR,
  TM: CountryCode.TKM,
  TC: CountryCode.TCA,
  TV: CountryCode.TUV,
  UG: CountryCode.UGA,
  UA: CountryCode.UKR,
  AE: CountryCode.ARE,
  GB: CountryCode.GBR,
  US: CountryCode.USA,
  UM: CountryCode.UMI,
  UY: CountryCode.URY,
  UZ: CountryCode.UZB,
  VU: CountryCode.VUT,
  VE: CountryCode.VEN,
  VN: CountryCode.VNM,
  VI: CountryCode.VIR,
  WF: CountryCode.WLF,
  EH: CountryCode.ESH,
  YE: CountryCode.YEM,
  ZM: CountryCode.ZMB,
  ZW: CountryCode.ZWE,
}

/**
 * Converts a ISO 3166-1 alpha-2 country code to an ISO 3166-1 alpha-3 country code
 */
export function getCountryISO3(countryCodeIso2: string): CountryCode | undefined {
  return countryISOMapping[countryCodeIso2]
}
